import axios from "../../utils/axios";
import type { RiskAssessmentAiReplyDTO, SendRiskAssessmentAiMessageRequest } from "../types/riskAssessmentAiDtos";

const apiUrl = process.env.REACT_APP_HS_API_URL;

const sendMessage = (request: SendRiskAssessmentAiMessageRequest) =>
    axios.post<RiskAssessmentAiReplyDTO>(`${apiUrl}/RiskAssessmentAi/Message`, request);

const riskAssessmentAiService = {
    sendMessage,
};

export default riskAssessmentAiService;
